module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "view-container"
  }, [_h('keep-alive', [_h('router-view', {
    staticClass: "view"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-214ea38b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewContainer.vue
// module id = 214
// module chunks = 2